import React from 'react';
import { QuoteIcon } from 'lucide-react';
const quotes = ['This gave me the confidence I didn\u2019t get from my certification — my first classes finally feel steady.', 'The script vault alone saved me from freezing up in my second class ever.', 'The adaptations chapter is worth it on its own — I finally know what to do for real bodies, not just the demo body.', 'Everything is ready to go — I stopped rebuilding my class plan every week.', 'Beautifully organized and genuinely useful, not just theory.', 'Best $19 I\u2019ve spent since getting certified.'];
export function Testimonials() {
  return <section className="w-full bg-cream-deep px-5 py-16 sm:py-24" data-id="element-177" data-mp="2x1kzar0m4lw6">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="2s1yospc65jr2">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-179" data-mp="2s39p2f6eo9df">
          What Yoga Teachers Are Saying.
        </h2>
        <p className="mt-4 text-center text-lg tracking-[0.2em]" aria-label="5 out of 5 stars" data-id="element-180" data-mp="qall23lxthwl">
          <span aria-hidden="true" data-id="element-181" data-mp="h67x3xu3nc77">⭐⭐⭐⭐⭐</span>
        </p>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-182" data-mp="h4n5afz667d1">
          {quotes.map(quote => <li key={quote} className="flex flex-col rounded-3xl border border-sage/25 bg-cream-card p-7" data-id="element-183" data-mp="m2yeqpljyfuq">
              <QuoteIcon className="h-5 w-5 flex-none text-terracotta" aria-hidden="true" data-id="element-184" data-mp="c624aec3fjnj" />
              <p className="mt-4 flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-185" data-mp="zvwh4vwex87s">"{quote}"</p>
              <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-sage" data-id="element-186" data-mp="14w28eayrsspc">
                [Placeholder]
              </p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center text-xs leading-relaxed text-ink-soft" data-id="element-187" data-mp="v5prqtu2tjoh">
          Review copy is provided as a placeholder and should be replaced with verified customer
          feedback before publishing.
        </p>
      </div>
    </section>;
}